import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BaseFillDataFormComponent} from '../base-fill-data-form-component';

@Component({
  selector: 'app-label-input',
  templateUrl: './label-input.component.html'
})
export class LabelInputComponent extends BaseFillDataFormComponent {
  @Input() inputName: string;
  @Input() inputLabel: string;
  @Input() inputType = 'text';
  @Input() formGroup: FormGroup;
  @Input() mask: string;

  private dateMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  private postalCodeMask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/];

  getMask() {
    let mask;
    switch (this.mask) {
      case 'postalCode':
        mask = this.postalCodeMask;
        break;
      case 'date':
        mask = this.dateMask;
        break;
      default:
        mask = false;
        break;
    }
    return {
      mask: mask,
      keepCharPositions: true
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/widgets/form-section/label-input/label-input.component.ts